import { Text } from '@wix/wix-ui-tpa/cssVars';
import React from 'react';
const JapanPostalCodeMarkWUT = () => {
  return /*#__PURE__*/React.createElement(Text, null, '\u3012');
};
export default JapanPostalCodeMarkWUT;
//# sourceMappingURL=japan-postal-code-mark-wut.js.map